import { CheckoutOffer } from './checkout-offer.interface';

export interface CheckoutBasket {
  channelSourceData: {
    checkoutSourceRef: string;
  };
  offers: CheckoutOffer[];
}
